// extracted by mini-css-extract-plugin
export default {"warpper":"uploadErrorImage_warpper__K3lkK","desc":"uploadErrorImage_desc__Vgrh+","num":"uploadErrorImage_num__R7dGv","imageUpload":"uploadErrorImage_imageUpload__AXOQj"};